<template>
    <main class="main" v-if="order">
        <div class="container order-view-page">
            <h1>{{ trans('THANKS') }},<br>{{ trans(isPaid ? 'YOUR ORDER HAS BEEN PAID' : 'YOUR ORDER HAS BEEN PLACED') }}!
            </h1>
            <h4>{{ trans('Order number') }}: {{ order.id }}</h4>
            <div v-if="showPay">
                <p>
                    <span>{{ trans('To complete, you need to pay for the order') }}. </span>
                    <span>
                    <span>{{ trans('To pay for the order, click') }}</span>
                    <span class="link_underline"> «{{ trans('To pay') }}» </span>
                </span>
                </p>
            </div>
            <p v-if="!isPaid">{{ trans('Information about the order has been sent to your email') }}
                <strong>({{ order.email }})</strong></p>
            <p v-if="$store.state.settings.site_id == 1 && order.payment_method == 'cash'">
                <span>{{ trans('The manager will contact you by phone soon to clarify the details of the order') }}</span>
                <span v-if="false">{{ trans('Due to the New Year holidays, the manager will contact you after 5.01 to confirm your order') }}</span>
            </p>
            <p v-if="$store.state.settings.site_id === 1 && order.payment_method == 'cash'">
                <span>{{trans('We will contact you during working hours: Mon-Fri from 10:00 to 19:00 (MSC)')}}</span>
            </p>

            <div>
                <button @click.prevent="getPayment" class="btn btnV2" v-if="showPay">{{ trans('To pay') }}</button>
            </div>
            <span @click="order_show = !order_show" id="switch-order-details"
                  class="link link_underline link_black">{{ trans('View order information') }}
            <img src="https://batnorton.com/img/svg/select-ar.svg" alt="">
        </span>
            <div class="order-view-page__details" v-show="order_show">

                <h4 v-if="cards.length == 1">{{ trans('You ordered') }} {{cards.length}} {{this.trans('product')}}</h4>
                <h4 v-else-if="cards.length >= 2 || cards.length <= 4">{{ trans('You ordered') }} {{cards.length}} {{this.trans('products')}}</h4>
                <h4 v-else-if="cards.length >= 5 ">{{ trans('You ordered') }} {{cards.length}} {{this.trans('productss')}}</h4>
                <hr>
                <div class="order-view-page__basket">

                    <div class="cart-sec__element_wrapper" v-for="card in cards">
                        <div class="cart-sec__element cart-element">
                            <a :href="card.img" class="cart-element__img">
                                <picture>
                                    <source :srcset="card.img"
                                            type="image/webp">

                                    <img class="img-element"
                                         :src="card.img" :alt="card.name">
                                </picture>
                            </a>
                            <div class="cart-element__info">
                                <h3 class="cart-element__title">

                                    <a class="cart-element__link"
                                                 :to="card.slug">{{ card.name }}
                                    </a>
                                </h3>
                                <div class="cart-element__size">{{ trans('Size') }}:

                                    <b>{{ card.size_code }}</b>
                                </div>

                                <div class="">
                                    <template v-if="card.price_str">
                                        <template v-if="card.price_old_str">
                                            <span class="cart-element__price product__sale-price" style="margin-right: 8px">
                                                {{ card.price_str }} {{ order.currency.sign }}
                                            </span>
                                            <span class="cart-element__price  product__old-price ">
                                                {{ card.price_old_str }} {{order.currency.sign}}
                                            </span>
                                        </template>
                                        <span class="cart-element__price  product__text-def " v-if="!card.price_old_str">{{card.price_str}} {{ order.currency.sign }}</span>
                                    </template>
                                    <template v-else-if="card.price_current">
                                        <span class="cart-element__price  product__text-def">{{card.price_current}} {{ order.currency.sign }}</span>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <table class="order-page__price-table">
                    <tbody>
                    <tr v-for="head in orderData.head">

                        <td class="order-view-page__table-header">{{ head.name }}</td>
                        <td class="order-page__price-table-value-cell">{{ head.value }}</td>
                    </tr>
                    </tbody>
                </table>

                <table class="order-page__price-table">
                    <tbody>
                    <tr v-for="body in orderData.body">
                        <td class="order-view-page__table-header">{{ body.name }}</td>
                        <td class="order-page__price-table-value-cell">{{ body.value }}</td>
                    </tr>
                    </tbody>
                </table>
                <table class="order-page__price-table">
                    <tbody>
                    <tr class="order-page__total-row" v-for="total in orderData.total">
                        <td class="order-view-page__table-header">{{ total.name }}</td>
                        <td class="order-page__price-table-value-cell">{{ total.value }}</td>
                    </tr>
                    </tbody>
                </table>
                <table v-if="order.payInInst" class="order-page__price-table">
                    <tbody>
                    <tr>
                        <td class="order-view-page__table-header">Оплати сейчас</td>
                        <td class="order-page__price-table-value-cell">{{ order.payInInst.firstPayStr }}</td>
                    </tr>
                    <tr>
                        <td class="order-view-page__table-header">При получении</td>
                        <td class="order-page__price-table-value-cell">{{  order.payInInst.secondPayStr }}</td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <Viewed></Viewed>
    </main>
</template>


<script>
import Viewed from '../../components/viewed.vue'
import { purchase as ga4PurchaseEvent } from '../../services/ga4Ecommerce.js'
export default {
    components:{
        Viewed
    },
    name: "thank",
    props: {
        order: Object,
        cards: Array,
        orderData: Object,
        cloudPaymentsReceipt: {
            type: Object,
            default: null,
        },
        ga4Purchase: {
            type: Object,
            default: null,
        },
    },
    created() {
        var scripts = [
            "https://widget.cloudpayments.ru/bundles/cloudpayments.js",

        ];
        scripts.forEach(script => {
            let tag = document.createElement("script");
            tag.setAttribute("src", script);
            document.head.appendChild(tag);
        });
    },
    data() {
        return {
            // order:null,
            order_basket: null,
            order_show: false,
        }
    },
    mounted() {
        if (this.order.newOrder) {
            this.getBasket()
        }
        if (this.ga4Purchase) {
            ga4PurchaseEvent(this.ga4Purchase)
        }
    },
    computed: {
        isPaid() {
            return Number(this.order?.document_id) === 1 || Boolean(this.order?.payment_date)
        },
        showPay() {
            const statusId = Number(this.order?.status_id)
            return this.order?.payment_method !== 'cash'
                && !this.isPaid
                && (statusId === 1 || statusId === 2 || statusId === 6)
        },
    },
    methods: {
        /*
        async getOrder() {
            await axios.get('/api/v1/get-order', {
                params:this.setParam({
                    order: this.order_id,
                    lang: this.$store.state.settings.lang,
                })
            })
                .then(data => {
                    this.order = data.data;


                }, err => {
                    this.$router.push('/404')
                }).then(this.getBasket)
        },
         */
        buildVkFeedId(card) {
            const cardId = card?.card_id
            const categoryId = card?.menu_id
            const gender = card?.gender_id == 1 ? 'M' : 'F'

            return cardId + '-' + categoryId + '-' + gender
        },
        getBasket() {
            let cards
            cards = this.cards.map((item) => {
                return {
                    "id": this.buildVkFeedId(item),
                    "name": item.name,
                    // фактическая цена за единицу после всех скидок (в т.ч. за способ оплаты)
                    "price": item.price_num,
                    "brand": "Batnorton",
                    "category": item.category_name,
                    "variant": item?.color?.name,
                    "quantity": 1,
                    "position": 1
                }
            })

            if (this.$store.state.settings.site_id === 1 && import.meta.env.MODE === 'production') {

                _tmr.push({
                    type: "reachGoal",
                    id: 3290316,
                    value: this.order.total,
                    goal: "purchase",
                    params: { product_id: cards.map(item => item.card_id)}
                });

                window.dataLayer = window.dataLayer || []
                dataLayer.push({
                    "ecommerce": {
                        "currencyCode": "RUB",
                        "purchase": {
                            "actionField": {
                                "id": this.order.id
                            },
                            "products": cards
                        }
                    }
                });
            }
            if (this.$store.state.settings.site_id === 2 && import.meta.env.MODE === 'production') {
                console.log('Placed Order')

                const items = cards.map((item, index) => ({
                    ProductID: item.card_id,
                    ItemName: item.name,
                    ItemPrice: item.price_num,
                    Quantity: item.quantity || 1,
                    Category: item.category_name,
                }))

                klaviyo.track('Placed Order', {
                    value: this.order.total,
                    Items: items
                });
            }
        },
        /*
        async successOrder(transactionId, amount) {
            await axios.post('/api/v1/get-order-success', this.setParam({
                transactionId: transactionId,
                order: this.$route.params['order'],
            }))
                .then(data => {
                    if (data.data == 'success') {
                        //платеж прошел
                    } else {
                        //платеж не прошел
                    }
                })
        },
         */
        paymentCloud(parts = null){
            let option
            let payments = new cp.CloudPayments({
                language: "ru-RU",
                email: this.order.email,
                applePaySupport: true,
                googlePaySupport: true,
                yandexPaySupport: true,
                tinkoffPaySupport: true,
                tinkoffInstallmentSupport: true,
                sbpSupport: true,
            });

            let order = this.order
            const payOptions = {
                    publicId: (import.meta.env.MODE === 'production') ? "pk_432d5c5177f43af37c632c880e4f8" : "pk_c7dad6260d7651668725a78ec3671",
                    description: "Оплата заказа #" + order.id,
                    amount: parts ? order.payInInst.firstPay : order.total,
                    currency: "RUB",
                    invoiceId: String(order.id),
                    accountId: order.id,
                    email: order.email,
                    skin: "classic",
                    requireEmail: true,
            }
            if (this.cloudPaymentsReceipt) {
                payOptions.receipt = this.cloudPaymentsReceipt
                payOptions.receiptEmail = order.email
            }
            payments.pay("charge", payOptions,
                {
                    onSuccess: function (options) { // success
                        option = options
                        console.log(options)
                    },
                    onFail: function (reason, options) {
                        console.log(reason, options)

                    },
                    onComplete: function (paymentResult, options) {
                        console.log(paymentResult, options)


                    }
                }).then(function (widgetResult) { //success
                console.log(widgetResult, option)
                if (widgetResult.status === 'success') {
                    const thanksId = order.thanks_id || `${order.guest_id}-${order.id}`
                    window.location.href = "/personal/order/thanks/" + thanksId;

                }
                if (widgetResult.type === 'cancel') {
                    //отмена пользователем
                    this.$notify({
                        title: this.trans('Notification'),
                        text: 'Errors',
                        type: 'error',
                    });
                }

            }).catch(function (error) {
                console.log(error)
            });
        },
        paymentDolyame(){
            window.location.href = "/payment/dolyame/order/"+this.order.id+'?lang='+this.$store.state.settings.lang+'&currency='+this.$store.state.settings.currency+"&site_id="+this.$store.state.settings.site_id;
        },
        paymentPaypal(){
            window.location.href = "/payment/paypal/order/"+this.order.id+'?lang='+this.$store.state.settings.lang+'&currency='+this.$store.state.settings.currency+"&site_id="+this.$store.state.settings.site_id;

        },
        paymentStripe(){
            window.location.href = "/payment/stripe/order/"+this.order.id+'?lang='+this.$store.state.settings.lang+'&currency='+this.$store.state.settings.currency+"&site_id="+this.$store.state.settings.site_id;

        },
        paymentYandexSplit() {
            window.location.href = "/payment/split/order/"+this.order.id+'?lang='+this.$store.state.settings.lang+'&currency='+this.$store.state.settings.currency+"&site_id="+this.$store.state.settings.site_id;
        },
        getPayment() {

            console.log(this.order)
            if(this.order.payment_method === 'cloud_payments'){
                this.paymentCloud()
            }

            if(this.order.payment_method === 'cloud_payments_parts'){
                this.paymentCloud('parts')
            }

            if(this.order.payment_method === 'dolyame'){
                this.paymentDolyame()
            }

            if(this.order.payment_method === 'paypal'){
                this.paymentPaypal()
            }

            if(this.order.payment_method === 'stripe'){
                this.paymentStripe()
            }

            if(this.order.payment_method === 'yandex_split'){
                this.paymentYandexSplit()
            }
        }
    }
}
</script>

<style scoped>

</style>
